"use strict";
require.context("../../images", true);
if (process.env.NODE_ENV === "development") {
  require("./sjma_development_service_worker_cleanup");
}
